import { PartialNullable } from "../types";
import { useCallback, useState } from "react";
import { useDeepCompareEffect } from "./use-deep-compare-effect";
import { ValidationError } from "../components/ValidationInputWrapper";
import _ from "lodash";

export function useValidationErrors<T>(
  entity: PartialNullable<T>,
  prefix?: string,
) {
  const [invalidEntity, setInvalidEntity] = useState<PartialNullable<T>>({});
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>(
    [],
  );

  const handleSetValidationErrors = useCallback(
    (errors: ValidationError[], invalidEntity: PartialNullable<T>) => {
      setInvalidEntity(invalidEntity);
      setValidationErrors(errors);
    },
    [],
  );

  useDeepCompareEffect(() => {
    const errors = validationErrors.filter((error) => {
      const path = prefix != null ? `${prefix}.${error.attr}` : error.attr;
      const lastValue = _.get(entity, path, null);
      const newValue = _.get(invalidEntity, path, null);
      return _.isEqual(lastValue, newValue);
    });

    setValidationErrors(errors);
  }, [entity, validationErrors, invalidEntity]);

  return {
    validationErrors,
    setValidationErrors: handleSetValidationErrors,
  };
}
